import { IntegrationType } from "../../../shared/models/mail-integration.model"


export const SMS_INTEGRATIONS_TYPE_LIST = [
  IntegrationType.SmsBump
];
